import React from "react";
import rcsPic from "../../../assets/img/mobileScreens/RCS.png";
import imagePlaceholder from "../../../assets/img/placeholder.jpg";

const currentTime = new Date().toLocaleTimeString([], {
  hour: "2-digit",
  minute: "2-digit",
});

const RcsTemplatePreview = ({
  templateType,
  textMessage,
  suggestions,
  mediaFile,
  title,
  description,
  carouselCards,
}) => {

  const highlightTemplateContent = (content) => {
    // Match both {{digit}} AND [custom_param_text_1]
    const parts = content.split(/(\{\{\d+\}\}|\[custom_param_[^\]]+\])/);
  
    return parts.map((part, index) => {
      const isPlaceholder =
        /\{\{\d+\}\}/.test(part) ||
        /\[custom_param_[^\]]+\]/.test(part);
  
      if (isPlaceholder) {
        return (
          <span key={index} style={{ color: "blue", fontWeight: 600 }}>
            {part}
          </span>
        );
      }
  
      return (
        <span key={index} style={{ whiteSpace: "pre-wrap" }}>
          {part}
        </span>
      );
    });
  };

  return (
    <div className="img-cont">
      <img src={rcsPic} alt="rcs preview" />
      <div className="preview-cont">
        {(templateType === "text_message" || templateType === "standard") && (
          <div className="whatsBody">
            <span className="w-body">{highlightTemplateContent(textMessage)}</span>
            <br />
            <div className="time_box">
              <span className="ms-auto">{currentTime}</span>
            </div>
            <div className="wdivider" />
            {suggestions.map((suggestion, idx) => (
              <div key={idx} className="whatsButton">
                <span className="btn-txt">{suggestion.text}</span>
              </div>
            ))}
          </div>
        )}

        {templateType === "rich_card" && (
          <div className="whatsBody">
            {mediaFile &&
              mediaFile.type &&
              mediaFile.type.startsWith("image/") && (
                <img
                  src={
                    mediaFile
                      ? URL.createObjectURL(mediaFile)
                      : imagePlaceholder
                  }
                  className="w-image"
                  alt="media"
                  style={{
                    minWidth: "auto",
                    maxWidth: "-webkit-fill-available",
                  }}
                />
              )}
            {mediaFile &&
              mediaFile.type &&
              mediaFile.type.startsWith("video/") && (
                <video
                  controls
                  className="w-image"
                  style={{ width: "100%", maxHeight: 180 }}
                >
                  <source
                    src={
                      mediaFile
                        ? URL.createObjectURL(mediaFile)
                        : imagePlaceholder
                    }
                    type={mediaFile.type}
                  />
                  Your browser does not support the video tag.
                </video>
              )}
            {mediaFile &&
              mediaFile.type &&
              mediaFile.type.startsWith("audio/") && (
                <audio controls className="w-image" style={{ width: "100%" }}>
                  <source
                    src={
                      mediaFile
                        ? URL.createObjectURL(mediaFile)
                        : imagePlaceholder
                    }
                    type={mediaFile.type}
                  />
                  Your browser does not support the audio tag.
                </audio>
              )}
            {!mediaFile && (
              <img
                src={imagePlaceholder}
                className="w-image"
                alt="media"
                style={{ minWidth: "auto", maxWidth: "-webkit-fill-available" }}
              />
            )}
            <span className="w-header">{title}</span>
            <span className="w-body">{description}</span>
            <br />
            <div className="time_box">
              <span className="ms-auto">{currentTime}</span>
            </div>
            <div className="wdivider" />
            {suggestions.map((suggestion, idx) => (
              <div key={idx} className="whatsButton">
                <span className="btn-txt">{suggestion.text}</span>
              </div>
            ))}
          </div>
        )}

        {templateType === "carousel" && carouselCards.length > 0 && (
          <>
            <div className="whatsBody">
              <span className="w-body">Carousel Preview</span>
              <br />
              <div className="time_box">
                <span className="ms-auto">{currentTime}</span>
              </div>
            </div>
            <div className="cards-container cards-slider">
              {carouselCards.map((card, index) => (
                <div key={index} className="cardsBody">
                  {card.mediaFile &&
                    card.mediaFile.type &&
                    card.mediaFile.type.startsWith("image/") && (
                      <img
                        src={
                          card.mediaFile.preview
                            ? card.mediaFile.preview
                            : URL.createObjectURL(card.mediaFile)
                        }
                        className="w-image"
                        alt="carousel"
                        style={{
                          minWidth: "auto",
                          maxWidth: "-webkit-fill-available",
                        }}
                      />
                    )}
                  {card.mediaFile &&
                    card.mediaFile.type &&
                    card.mediaFile.type.startsWith("video/") && (
                      <video
                        controls
                        className="w-image"
                        style={{ width: "100%", maxHeight: 180 }}
                      >
                        <source
                          src={
                            card.mediaFile.preview
                              ? card.mediaFile.preview
                              : URL.createObjectURL(card.mediaFile)
                          }
                          type={card.mediaFile.type}
                        />
                        Your browser does not support the video tag.
                      </video>
                    )}
                  {card.mediaFile &&
                    card.mediaFile.type &&
                    card.mediaFile.type.startsWith("audio/") && (
                      <audio
                        controls
                        className="w-image"
                        style={{ width: "100%" }}
                      >
                        <source
                          src={
                            card.mediaFile.preview
                              ? card.mediaFile.preview
                              : URL.createObjectURL(card.mediaFile)
                          }
                          type={card.mediaFile.type}
                        />
                        Your browser does not support the audio tag.
                      </audio>
                    )}
                  {!card.mediaFile && (
                    <img
                      src={imagePlaceholder}
                      className="w-image"
                      alt="carousel"
                      style={{
                        minWidth: "auto",
                        maxWidth: "-webkit-fill-available",
                      }}
                    />
                  )}
                  <span className="w-header">{card.title}</span>
                  <span className="w-body">{card.description}</span>
                  <div className="wdivider" />
                  {(card.suggestions || []).map((button, idx) => (
                    <div key={idx} className="whatsButton">
                      <span className="btn-txt">{button.text}</span>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default RcsTemplatePreview;
